import { createReducer, on } from '@ngrx/store';
import {
  FinishCreateReference,
  FinishGetReferences,
  InitCreateReference,
  InitGetReferences,
} from '@core/state/reference/reference.actions';

export interface ReferenceState {
  loadingReferenceForm: boolean;
  loadingGetReferences: boolean;
}

export const initialReferenceState: ReferenceState = {
  loadingReferenceForm: false,
  loadingGetReferences: false,
};

export const referenceReducer = createReducer(
  initialReferenceState,
  on(InitCreateReference, (state) => {
    return {
      ...state,
      loadingReferenceForm: true,
    };
  }),
  on(FinishCreateReference, (state) => {
    return {
      ...state,
      loadingReferenceForm: false,
    };
  }),
  on(InitGetReferences, (state) => {
    return {
      ...state,
      loadingGetReferences: true,
    };
  }),
  on(FinishGetReferences, (state) => {
    return {
      ...state,
      loadingGetReferences: false,
    };
  })
);
